import Section, {html, css} from './_section'

customElements.define('steens-form-section-medical', class extends Section{

    get title(){ return '🚑 Medical' }

    // static get styles(){return css`
    //     :host {
    //         display: block;
    //         position:relative;
    //     }
    // `}

    renderControls(){return html`
        <b-grid>
            <form-control material="filled" key="medical_insurance" label="Insurance Co.">
                <input slot="control" type="text">
            </form-control>

            <form-control material="filled" key="medical_policy_num" label="Group/Policy #">
                <input slot="control" type="text">
            </form-control>

            <div>
                <b-btn @click=${this.fillMedForm} class="med-history-btn">Medical History</b-btn>
            </div>

        </b-grid>
    `}

    fillMedForm(e){
        this.emitEvent('fill-med-form', {btn: e.currentTarget})
    }

})